if (!customElements.get('share-button')) {
  customElements.define(
    'share-button',
    class ShareButton extends DetailsDisclosure {
      constructor() {
        super();

        this.elements = {
          shareButton: this.querySelector('button'),
          shareSummary: this.querySelector('summary'),
          closeButton: this.querySelector('.share-button__close'),
          successMessage: this.querySelector('[id^="ShareMessage"]'),
          urlInput: this.querySelector('input'),
        };

        this.urlToShare = this.elements.urlInput ? this.elements.urlInput.value : document.location.href;
        this.whatsappNumber = '818070680114';
        this.messageText = 'Hello, is this product still available?';

        this.elements.shareButton.classList.remove('hidden');

        this.elements.shareButton.addEventListener('click', (e) => {
          e.preventDefault();
          const fullMessage = `${this.messageText}\n${this.urlToShare}`;
          const whatsappLink = `https://wa.me/${this.whatsappNumber}?text=${encodeURIComponent(fullMessage)}`;
          window.open(whatsappLink, '_blank');
        });

        // Optional: disable the toggle/copy functionality entirely
        this.mainDetailsToggle.setAttribute('hidden', '');
      }

      // If you still want to support clipboard fallback, leave these methods:
      toggleDetails() {}
      copyToClipboard() {}
      updateUrl(url) {
        this.urlToShare = url;
        this.elements.urlInput.value = url;
      }
    }
  );
}
